import { isValidCNPJ } from './cnpj';
import { isValidCPF } from './cpf';

export const getPersonType = (document: string) => {
  if (isValidCPF(document)) {
    return 'F';
  }

  if (isValidCNPJ(document)) {
    return 'J';
  }

  return 'F';
};

export const PERSON_NAME_REGEX = /^[\p{L}\d\s'./-]+$/u;
const REPEATED_CHAR_REGEX = /(\p{L})\1{2,}/iu;
const WORD_SPLIT_REGEX = /\s+/;
const MIN_WORDS_IN_FULL_NAME = 2;
const MIN_WORD_LENGTH = 1;

export const isLikelyValidName = (value: string): boolean => {
  const trimmed = value.trim();

  if (REPEATED_CHAR_REGEX.test(trimmed)) {
    return false;
  }

  const words = trimmed.split(WORD_SPLIT_REGEX);

  if (words.length < MIN_WORDS_IN_FULL_NAME) {
    return false;
  }

  return words.every(word => {
    if (word.length < MIN_WORD_LENGTH) {
      return false;
    }

    return true;
  });
};
